import { VueConstructor } from 'vue';

const disable = (element: HTMLInputElement) => {
  const attr = element.getAttribute('autocomplete');
  if (!attr || attr === 'off') {
    element.setAttribute('autocomplete', 'fake-area');
  }
};

const disableAutocomplete = {
  install(Vue: VueConstructor) {
    Vue.directive('disable-autocomplete', {
      bind(el) {
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName)) {
          disable(el as HTMLInputElement);
        } else {
          const inputs = el.querySelectorAll('input,textarea,select') as any;
          inputs.forEach(disable);
        }
      },
      componentUpdated(el) {
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName)) {
          disable(el as HTMLInputElement);
        } else {
          const inputs = el.querySelectorAll('input,textarea,select') as any;
          inputs.forEach(disable);
        }
      },
    });
  },
};

export default disableAutocomplete;
